import { useState, useEffect } from "react";
import "./QuestionSettingsDate.css";
import { QuestionSelector } from "../question-selector/QuestionSelector";
import { Question, QuestionType, UpdateQuestionPayload } from "effno-core";
import { apiUpdateQuestion } from "../../services/QuestionService";
import toast from "react-hot-toast";
import { toastFail } from "../../config";
import { DATE_FORMAT_DEFAULT, DATE_FORMATS } from "../config/questionSettings";
import { MySwitch } from "../form-widgets/MySwitch";
import { GenericSelect, GenericSelectOption } from "../form-widgets/GenericSelect";

type QuestionSettingsDateProps = {
    question: Question;
    onChange: (question: Question) => void;
}

export const QuestionSettingsDate = ({question, onChange} : QuestionSettingsDateProps) => {

    const [settings, setSettings] = useState<any | null>(JSON.parse(question.settings));
    const [type, setType] = useState<QuestionType>(question.type);
    const [required, setRequired] = useState<boolean>(question.required);

    useEffect(() => {
        setSettings(JSON.parse(question.settings));
        setRequired(question.required);
        setType(question.type);
    }, [question]);

    const handleTypeChange = async (value: string) => {
        console.log("[QuestionSettingsEmail/handleTypeChange] value: ", value);
    }

    const handleRequiredChange = async (checked: boolean) => {
        setRequired(checked);

        const payload: UpdateQuestionPayload = {
            questionId: question.id,
            type,
            title: question.title,
            description: question.description,
            required: checked,
            settings: JSON.stringify(settings),
            conditions: question.conditions
        }

        updateSettings(payload);
    }

    const handleChangeFormat = async (value: any) => {
    
        console.log("[QuestionSettingsDate/handleChangeFormat] value: ", value);
        const newSettings = {...settings, dateFormat: value};

        setSettings(newSettings);

        const payload: UpdateQuestionPayload = {
            questionId: question.id,
            type,
            title: question.title,
            description: question.description,
            required,
            settings: JSON.stringify(newSettings),
            conditions: question.conditions
        }

        await updateSettings(payload)

    }

    // have to send in the payload here due to react setting asyncs
    const updateSettings = async(payload: UpdateQuestionPayload) => {

        const newQuestion = await apiUpdateQuestion(payload);

        if (!newQuestion) {
            toast("Error updating question", toastFail);
            return;
        }

        // update UI
        onChange(newQuestion);
    }

    // console.log("[QuestionSettingsEmail] settings: ", settings);
    const options = DATE_FORMATS.map((format: string) => {
        return ({
            value: format,
            displayName: format,
        } as GenericSelectOption)
    });

    return (        
        <>
            <div className="question-settings-date">
                {/* <QuestionSelector defaultValue={type} onChange={handleTypeChange}/>

                <div className="question-setting-divider">{}</div> */}

                <div className="question-setting">
                    <div className="question-setting-label">
                        Required
                    </div>
                    <div className="question-setting-checkbox">
                        <MySwitch 
                            id="required"
                            checked={required}
                            onChange={(checked: boolean) => 
                                handleRequiredChange(checked)
                            }                        
                        />
                    </div>
                </div>

                <div className="question-setting">
                    <div className="question-setting-label">
                        Date Format
                    </div>
                    <div 
                        className="question-setting-select"
                        style={{width: "110px", marginLeft: "auto"}}
                    >
                        <GenericSelect
                            selected={options[0]}
                            options={options}
                            onChange={handleChangeFormat}
                        />
                        
                       {/* <select 
                            value={settings?.dateFormat || DATE_FORMAT_DEFAULT}
                            onChange={handleChangeFormat}
                            data-testid="dateFormat"
                        >
                            {DATE_FORMATS.map((format: string) => {
                                return (
                                    <option 
                                        key={"date-format-" + format}
                                        value={format}
                                    >
                                        {format}
                                    </option>
                            )})}
                        </select> */}
                    </div>
                </div>

                <div className="question-setting-stack">
                    

                </div>
            </div>
            
        </>
    )
}